import "../../App.css";
import Sidebar from "../Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import AutocompleteInputModule from "../AutoComplete";
import Parametros from "../Parametros";
import "../../styles/autocomplete.css";
import AutocompleteForms from "../AutocompleteForms";
import GeoAdminLupa from "../geoAdminLupa";
import CurrentUser from "../CurrentUser";
function Direccion(props) {
  const [update, setUpdate] = useState(false);
  const { history } = props;
  const [DireccionStateUpdate, setDireccionStateUpdate] = useState([]);
  const [DireccionState, setDireccionState] = useState([]);
  const [geoAdminList, setGeoAdminState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  useEffect(() => {
    async function llamadaApi() {
      let response2 = await fetch(Parametros.urlApi + "geoadmin", {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      });

      if (response2.status === 200 || response2.status === 201) {
        let responseJson2 = await response2.json();
        setGeoAdminState(responseJson2);
      }

      let response = await fetch(
        Parametros.urlApi + "address?is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);

        setDireccionStateUpdate(JSON.parse(responseJsonUpdate));
        setDireccionState(JSON.parse(responseJsonstate));
      }
    }
    llamadaApi();
  }, [update, usuario.key]);

  const [formularioState, setFormularioState] = useState({
    zip_code: 0,
    street: "",
    complement: "",
    coordinates: "",
    unit_number: "",
    geoadmin: "",
  });

  const [editable, setEditable] = useState({
    id: "",
  });

  let crearDireccion = async (event) => {
    event.preventDefault();

    if (usuario.permisos.indexOf("Crear") > -1) {
      let formulario = formularioState;
      console.log({ formulario });
      console.log({ geoAdminList });
      // formulario.geoadmin = geoAdminList.filter(
      //   (itemGeo) =>
      //     itemGeo.geoadmin1.trim() +
      //       "-" +
      //       itemGeo.geoadmin2.trim() +
      //       "-" +
      //       itemGeo.geoadmin3.trim() +
      //       "-" +
      //       itemGeo.geoadmin4.trim() +
      //       "-" +
      //       itemGeo.geoadmin5.trim() ===
      //     formulario.geoadmin
      // )[0].geoadmin_zone_id;
      formulario.zip_code = parseInt(formulario.zip_code);

      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "address", {
          method: "POST",
          body: JSON.stringify(formulario),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        if (response.status === 200 || response.status === 201) {
          let responseJson = await response.json();
          alert(responseJson.message);
          setUpdate(!update);

          event.target.reset();
        } else {
          let responseJson = await response.json();
          alert(responseJson.detail);
        }
      } else {
        alert(usuario.crear);
      }
    }
  };
  // eslint-disable-next-line
  let eliminarElemento = async (index, item) => {
    if (usuario.permisos.indexOf("Eliminar") > -1) {
      if (window.confirm("¿Esta seguro que deseas Eliminar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react
        let response = await fetch(
          Parametros.urlApi + "address/" + parseInt(item.address_id),
          {
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );

        let responseJson = await response.json();

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 201
        ) {
          alert(responseJson.message);
          setUpdate(!update);
          setEditable({});
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(JSON.stringify(responseJson.detail));
          setUpdate(!update);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.eliminar);
    }
  };
  let confirmarEdicion = async (item) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      geoAdminList.map((itemGeo) => {
        if (
          formularioUpdate.geoadmin &&
          itemGeo.geoadmin1.trim() +
            "-" +
            itemGeo.geoadmin2.trim() +
            "-" +
            itemGeo.geoadmin3.trim() +
            "-" +
            itemGeo.geoadmin4.trim() +
            "-" +
            itemGeo.geoadmin5.trim() ===
            item.geoadmin
        ) {
          formularioUpdate.geoadmin = itemGeo.geoadmin_zone_id;
        }
        return itemGeo;
      });

      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react
        let response = await fetch(
          Parametros.urlApi + "address/" + parseInt(item.address_id),
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(formularioUpdate),
          }
        );

        let responseJson = await response.json();

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 201
        ) {
          alert(responseJson.message);
          setEditable({});
          setUpdate(!update);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setDireccionState(JSON.parse(JSON.stringify(DireccionStateUpdate)));
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.editar);
    }
  };

  // eslint-disable-next-line
  let DireccionHandleChange = (index, e) => {
    let newList = DireccionState;
    newList[index][e.target.name] = e.target.value;
    setDireccionState(JSON.parse(JSON.stringify(newList)));
  };

  let handleStageForm = (e) => {
    const value = e.target.value ? e.target.value : e.currentTarget.innerText;
    const name = e.target.getAttribute("name");

    setFormularioState({
      ...formularioState,
      [name]: value,
    });
  };
  let handleStageFormRow = (
    index,
    e,
    setState,
    listaState,
    autocomplete,
    paramName
  ) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;
    let newList = JSON.parse(JSON.stringify(DireccionState));
    newList[index][name] = value;
    setDireccionState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let cancelarEdicion = () => {
    const nuevoObjeto = JSON.parse(JSON.stringify(DireccionStateUpdate));
    setDireccionState(nuevoObjeto);
    setEditable({});
  };
  let editar = (id) => {
    setDireccionState(JSON.parse(JSON.stringify(DireccionStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };

  return (
    <div className={props.sideBar ? "" : "App"}>
      {props.sideBar ? <></> : <Sidebar tipo="2"></Sidebar>}
      <br />
      <div className={props.sideBar ? "" : "container"}>
        {props.userTab ? <></> : <UserTab nombre={"Direcciones"}></UserTab>}
        <form
          id="formularioBusqueda"
          onSubmit={(e) => {
            if (!formularioState.geoadmin) {
              e.preventDefault();
              return alert("Seleccione una comuna");
            }
            crearDireccion(e);
          }}
        >
          <div className="col-md-4">
            <h5>Código Postal</h5>
            <input
              onChange={handleStageForm}
              name="zip_code"
              type={"number"}
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Calle</h5>
            <input
              onChange={handleStageForm}
              name="street"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Complemento</h5>
            <input
              onChange={handleStageForm}
              name="complement"
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Coordenadas</h5>
            <input
              onChange={handleStageForm}
              name="coordinates"
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Número</h5>
            <input
              onChange={handleStageForm}
              name="unit_number"
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Comuna</h5>
            <AutocompleteForms
              personalHandleChange={handleStageForm}
              nameElement={"geoadmin"}
              formularioBuscado={formularioState}
              setformulario={setFormularioState}
              required={true}
              value={formularioState.geoadmin}
              suggestions={geoAdminList.map((itemGeo) => {
                return {
                  value: itemGeo.geoadmin_zone_id,
                  label:
                    itemGeo.geoadmin1.trim() +
                    "-" +
                    itemGeo.geoadmin2.trim() +
                    "-" +
                    itemGeo.geoadmin3.trim() +
                    "-" +
                    itemGeo.geoadmin4.trim() +
                    "-" +
                    itemGeo.geoadmin5.trim(),
                };
              })}
            />
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(DireccionState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={[
              "Comuna",
              "Calle",
              "Número",
              "Complemento",
              "Código Postal",
              "Coordenadas",
            ]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table
              type={2}
              elementos={[
                "Comuna",
                "Calle",
                "Número",
                "Complemento",
                "Código Postal",
                "Coordenadas",
              ]}
            ></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {DireccionState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.address_id}>
                      {editable === item.address_id ? (
                        <>
                          <td>{item.address_id}</td>
                          <td>
                            <AutocompleteInputModule
                              name={"geoadmin"}
                              suggestions={geoAdminList.map((itemGeo) => {
                                return {
                                  value: itemGeo.geoadmin_zone_id,
                                  label:
                                    itemGeo.geoadmin1.trim() +
                                    "-" +
                                    itemGeo.geoadmin2.trim() +
                                    "-" +
                                    itemGeo.geoadmin3.trim() +
                                    "-" +
                                    itemGeo.geoadmin4.trim() +
                                    "-" +
                                    itemGeo.geoadmin5.trim(),
                                };
                              })}
                              i={index}
                              value={item.geoadmin}
                              setformularioUpdate={setformularioUpdate}
                              formularioUpdate={formularioUpdate}
                              handleInput={handleStageFormRow}
                              setState={setDireccionState}
                              state={DireccionState}
                            ></AutocompleteInputModule>
                          </td>
                          <td>
                            {" "}
                            <input
                              value={item.street ? item.street : ""}
                              name="street"
                              onChange={(event) => {
                                handleStageFormRow(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              value={item.unit_number ? item.unit_number : ""}
                              name="unit_number"
                              onChange={(event) => {
                                handleStageFormRow(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.complement ? item.complement : ""}
                              name="complement"
                              onChange={(event) => {
                                handleStageFormRow(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              value={item.zip_code ? item.zip_code : ""}
                              name="zip_code"
                              type={"number"}
                              onChange={(event) => {
                                handleStageFormRow(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.coordinates ? item.coordinates : ""}
                              name="coordinates"
                              onChange={(event) => {
                                handleStageFormRow(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.address_id}</td>
                          <td>
                            <GeoAdminLupa
                              autocomplete={true}
                              geoAdmin={item.geoadmin}
                              geoAdminList={geoAdminList}
                            />
                          </td>
                          <td>{item.street}</td>
                          <td>{item.unit_number}</td>
                          <td>{item.complement}</td>
                          <td>{item.zip_code}</td>
                          <td>{item.coordinates}</td>
                          <td>
                            <abbr title="Editar Elemento ">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.address_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            {/* <abbr title="Eliminar Elemento"> <span style={{ cursor: "pointer" }} onClick={() => { eliminarElemento(index, item) }} className='glyphicon glyphicon-remove'></span></abbr> */}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(DireccionState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Direccion);
